import { Injectable } from '@angular/core';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';

import { AuthorizationService } from '@assetaccountant/core/services/authorization.service';
import { ModalService } from '@assetaccountant/core/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { OidcStateParams } from '../models/oidc-state-params';

export const sageV2Config = {
  responseType: 'code',
  scope: environment.integrations.sageV2.scope,
  clientId: environment.integrations.sageV2.clientId,
  redirectUri: environment.integrations.sageV2.redirectUri,
  issuer: environment.integrations.sageV2.issuer,
};

@Injectable({
  providedIn: 'root',
})
export class SageV2Service {
  constructor(
    private modalService: ModalService,
    private authorizationService: AuthorizationService,
    private toastr: ToastrService,
  ) {}

  initiateOAuth(returnRoute: string) {
    const state = this.generateState(returnRoute);

    const url =
      sageV2Config.issuer +
      '?response_type=' +
      encodeURIComponent(sageV2Config.responseType) +
      '&client_id=' +
      encodeURIComponent(sageV2Config.clientId) +
      '&state=' +
      encodeURIComponent(state) +
      '&nonce=' +
      encodeURIComponent(state) +
      '&redirect_uri=' +
      encodeURIComponent(sageV2Config.redirectUri) +
      '&scope=' +
      encodeURIComponent(sageV2Config.scope);

    window.location.href = url;
  }

  generateState(returnRoute: string) {
    const stateParams = new OidcStateParams();
    stateParams.returnRoute = returnRoute;

    const state: string = btoa(JSON.stringify(stateParams));

    localStorage.setItem('aa-oidc-state', state);

    return state;
  }

  handleError(registerId, httpError, returnRoute) {
    if (
      httpError.status === 403 ||
      (Array.isArray(httpError.error) && httpError.error[0].message === 'invalid_grant') ||
      httpError.error.errorId === 'REST-1206' ||
      httpError.error.errorId === 'REST-2102'
    ) {
      if (
        registerId &&
        this.authorizationService.isRegisterAuthorized(
          registerId,
          RegisterPermissionType.CreateIntegrationConnection,
        )
      ) {
        this.modalService
          .showErrorModal(
            'We were unable to authenticate with Sage, please reconnect and try again.',
            'Authentication Failure',
            'Reconnect',
          )
          .subscribe(_ => this.initiateOAuth(returnRoute));
      } else {
        this.modalService.showErrorModal(
          'We were unable to authenticate with Sage, please ask an administrator to reconnect this register',
          'Authentication Failure',
          'OK',
        );
      }
    } else {
      let title = 'We detected an error while processing your request.';
      let message = httpError.error.message;

      if (httpError.error.errors && httpError.error.errors.length > 0) {
        title = message;
        message = httpError.error.errors[0];
      }

      this.toastr.error(message, title);
    }
  }
}
